import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Select root element
const rootEl = document.getElementById('root');

// Set initial loading text
if (rootEl) {
  rootEl.textContent = "Loading BPA Solutions form.";
}

// Global error handlers to prevent silent white screens
window.addEventListener("error", (e) => {
  if (rootEl) {
    rootEl.textContent = "App failed to load. Please refresh or contact support.";
  }
  console.error("Boot error:", e.error || e.message);
});

window.addEventListener("unhandledrejection", (e) => {
  if (rootEl) {
    rootEl.textContent = "App failed to load. Please refresh or contact support.";
  }
  console.error("Boot rejection:", e.reason);
});

// Boot log for verification
console.log("BPA Forms Hub booting", window.location.href);

// Robust mount with try-catch
try {
  if (rootEl) {
    const root = createRoot(rootEl);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  }
} catch (err) {
  if (rootEl) {
    rootEl.textContent = "App failed to start. Please refresh or contact support.";
  }
  console.error("Mount crash:", err);
}